import instance from "@/utils/require.js"

export function apiProductIqAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/product_iq/add",
		method: "post",
		data
	})
}
export function apiProductIqUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/product_iq/update",
		method: "post",
		data
	})
}

export function apiProductIqDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/product_iq/delete",
		method: "post",
		data
	})
}

export function apiProductIqSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/product_iq/search",
		method: "post",
		data
	})
}

export function apiProductIqEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/product_iq/enable",
		method: "post",
		data
	})
}

export function apiProductIqDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/product_iq/disable",
		method: "post",
		data
	})
}
